<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'CategoriesPage',

};
</script>

<style>

</style>
